<template lang="pug">
  .forgot-password-modal.modal-card
    template(v-if="success")
      header.modal-card-head
        p.modal-card-title Email Sent
      section.modal-card-body.has-background-info-light
        .is-size-2 {{ `A reset password email has been sent to:` }}
        .is-size-2 {{ `${email}` }}

      footer.modal-card-foot.custom-modal-card-foot
        WtButton(
          @click.native="$parent.close()"
          color="grey"
        ) OK
    template(v-else)
      header.modal-card-head
        p.modal-card-title Password Reset
      section.modal-card-body
        p.has-text-info
          BIcon(icon="information" size="is-small")
          | &nbsp;Please enter the email address for this account and we'll send you a link to reset your password.
        br
        BField(
          label="Email"
          label-for="email"
          :type="{ 'is-danger': errors.has('email') }"
          :message="errors.first('email')"
        )
          BInput(
            name="email"
            v-model="email"
            v-validate="`required|email`"
            @input="resetUserNotFoundPassword"
          )
        p.has-text-danger
          | {{showUserNotFoundError ? userNotFoundErrorMessage : null}}
      footer.modal-card-foot.custom-modal-card-foot
        WtButton(
          @click.native="$parent.close()"
          color="grey"
          is-text
        ) Cancel
        WtButton(
          @click.native="resetPassword"
          :loading="processingForgotPassword"
        ) Send reset link
</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "ForgotPasswordModal",

  components: { WtButton },

  data() {
    return {
      email: "",
      processingForgotPassword: false,
      success: false,
      userNotFoundErrorMessage:
        "The email you have entered doesn't match a member account for this program.",
      showUserNotFoundError: false
    };
  },

  methods: {
    ...mapActions("registration", ["forgotPassword"]),
    ...mapActions(["snackBar"]),

    async resetPassword() {
      const validates = await this.$validator.validateAll();
      if (!validates) {
        this.processingForgotPassword = false;
        return;
      }

      this.processingForgotPassword = true;

      try {
        const response = await this.forgotPassword(this.email);
        if (this._.get(response, "data.success", false)) {
          this.success = true;
        }
      } catch (error) {
        if (
          this._.get(error, "response.data.error.code", false) === "not-found"
        ) {
          this.showUserNotFoundError = true;
        }
      }
      this.processingForgotPassword = false;
    },

    resetUserNotFoundPassword() {
      this.showUserNotFoundError = false;
    }
  }
};
</script>

<style scoped lang="sass">
.forgot-password-modal
  .custom-modal-card-foot
    justify-content: flex-end
</style>
